import { Button, GoogleFontIcon } from '@asset-metrix/portal-ui';

import { isNotNull } from '../../utils/nullish';

import styles from './dashboardEmptyState.module.scss';

type DashboardEmptyStateProps = {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  withAddIcon?: boolean;
  'data-testid'?: string;
};

export function DashboardEmptyState({
  title,
  description,
  actionLabel,
  onAction,
  withAddIcon = false,
  'data-testid': dataTestId,
}: DashboardEmptyStateProps) {
  return (
    <div className={styles.root} data-testid={dataTestId}>
      <div className={styles.content}>
        <GoogleFontIcon className={styles.icon} name="space_dashboard" />
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        {isNotNull(actionLabel) && isNotNull(onAction) && (
          <Button
            icon={withAddIcon ? <GoogleFontIcon name="add" /> : undefined}
            onClick={onAction}
            title={actionLabel}
            variant="primary"
          >
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
